// Command palette open/closed flag, factored out of CommandPalette.svelte so
// Modal.svelte can see it too: Esc priority is palette-first, then modal
// (design pack §4) — Modal's own Escape handler no-ops while the palette is
// open, so one Esc press closes exactly one layer regardless of DOM/mount
// order, then the next press closes the modal.
class PaletteState {
  open = $state(false);

  toggle() {
    this.open = !this.open;
  }
  close() {
    this.open = false;
  }
}

export const palette = new PaletteState();
